<template>
  <!-- TODO: Refactoring homework + Modal +etc  -->
  <section v-if="isHomeworkLoaded" class="c-homework">
    <ModalHomework
      v-if="!userFilled"
      :description="description"
      @send-homework="handleSendHomework"
    >
    </ModalHomework>
    <section v-if="false" class="c-admin-message p-3 p-md-4">
      <div class="row justify-content-center align-items-center">
        <div class="col col-12 col-md-4 mb-4 md-md-0">
          <figure class="c-admin-message__vector">
            <img
              class="w-100 h-100 of--contain"
              src="../../assets/images/lection/homework/no-completed.png" alt=""
            />
          </figure>
        </div>
        <div class="col col-12 col-md-6 text-center text-md-left">
          <h3 class="white fs-21 w-bold">Necesitas completar el 80% del curso</h3>
          <p class="mb-4 w-medium medium-gray">
            No te apresures, ¡Disfruta de las lecciones! te esperamos de vuelta.
          </p>
          <router-link :to="lastLectionRoute" class="c-button c-button--primary d-inline-block">
            <i class="iconf-play fs-18 me-2"></i>
            <span class="d-inline-block d-md-none">Continuar clases</span>
            <span class="d-none d-md-inline-block">Continuar aprendiendo</span>
          </router-link>
        </div>
      </div>
    </section>
    <section
      v-if="showPresentationMessage"
      class="c-pulse-card p-3 p-lg-4 text-center white br--small overflow-hidden mb-5"
    >
      <div class="c-pulse-card__body">
        <div class="row justify-content-center">
          <div class="col col-12 col-md-8">
            <h3 class="fs-25 w-bold mb-3">¡Felicitaciones!</h3>
            <p class="mb-4 w-medium">
              Has completado todo el curso de {{ course.title }}.
              Para terminar y recibir tu certificado envía el trabajo desarrollado en el curso.
              Revisaremos tu trabajo y te enviaremos tu certificado el próximo lunes.
              ¡Saludos!
            </p>
            <a href="#workspace" class="c-button c-button--white-ghost d-inline-block">
              Enviar trabajo
            </a>
          </div>
        </div>
      </div>
      <div class="c-pulse-card__background">
        <span class="c-pulse-card__buble-left"></span>
        <span class="c-pulse-card__buble-right"></span>
      </div>
    </section>
    <section v-if="showLastActivityAlert" class="mb-5">
      <h3 class="white fs-21 w-bold mb-3">Ultima actividad</h3>
      <div class="c-card-alert c-card-alert--error-black p-2 p-lg-3">
        <div class="c-comment">
          <div class="d-flex">
            <Avatar
              :role="user.role"
              :name="firstTeacher.display_name"
              :photo="firstTeacher.photo"
              class="c-avatar--tiny me-3"
            />
            <div class="flex-grow-1">
              <div class="d-block d-md-flex align-items-center mb-2">
                <div class="d-flex align-items-center white">
                  <span class="w-bold">{{ firstTeacher.display_name }}</span>
                </div>
                <i class="c-comment__dot mx-3 d-none d-md-inline-block"></i>
                <time class="w-medium medium-gray d-block d-md-inline-block">
                  {{ review.date_create }}
                </time>
              </div>
              <p class="medium-gray mb-0">
                {{ review.comment }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="showHomeworkForm" id="workspace" class="c-workspace c-form c-form--black mb-4">
      <div class="row">
        <div :class="homeworkGrid">
          <div class="c-workspace__description mb-4">
            <h3 class="white fs-21 w-bold mb-3">Indicaciones</h3>
            <div class="mb-0 medium-gray w-medium" v-html="content.body.description"></div>
          </div>
          <div class="c-workspace__description mb-4">
            <h3 class="white fs-21 w-bold mb-3">Archivos a entregar</h3>
            <div class="mb-0 medium-gray w-medium" v-html="content.body.required_files"></div>
          </div>
          <div class="c-workspace__description">
            <h3 class="white fs-21 w-bold mb-3">¿Qué se evaluará en este curso?</h3>
            <div class="mb-0 medium-gray w-medium" v-html="content.body.evaluation_details"></div>
          </div>
        </div>
        <div v-if="!isTeacher" :class="homeworkGrid">
          <h3 class="white fs-21 w-bold mb-4">Enviar mi proyecto final</h3>
          <div class="mb-4">
            <h3 class="white fs-18 w-bold mb-2">Trabajo</h3>
            <div class="c-files d-flex flex-column align-items-center">
              <ul class="nav nav-tabs mb-4" role="tablist">
                <li class="nav-item" role="presentation">
                  <a
                    @click="handleChangeFormType('files')"
                    class="c-files__nav-link nav-link active"
                    data-toggle="tab"
                    href="#homework-files"
                    role="tab"
                    aria-selected="true"
                  >
                    <span class="c-files__buble me-2"></span> Subir archivos
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a
                    @click="handleChangeFormType('link')"
                    class="c-files__nav-link nav-link"
                    data-toggle="tab"
                    href="#homework-link"
                    role="tab"
                    aria-selected="false"
                  >
                    <span class="c-files__buble me-2"></span> Link
                  </a>
                </li>
              </ul>
              <div class="tab-content w-100">
                <div class="tab-pane fade show active" id="homework-files" role="tabpanel">
                  <div id="drop-area" class="c-form__ddrop mb-2">
                    <i class="c-icon iconf-doc-add mb-4"></i>
                    <h4 class="mb-1">Arrastrar y soltar archivos aquí</h4>
                    <div class="mb-2">
                      o
                      <label class="c-link">
                        seleccionar archivos
                        <input type="file" class="d-none">
                      </label>
                    </div>
                  </div>
                  <p class="mb-0 medium-gray fs-14 w-medium">
                    Extensiones permitidas: png, jpg, jpeg, zip, rar, mp4, mwv, avi, pdf
                  </p>
                  <div class="mt-3">
                    <ul class="c-files__list ul-reset">
                      <li v-for="(file, index) in files.data"
                        class="c-file"
                        :class="{ 'uploaded': file.percentage === 100 }"
                        :key="file.id"
                        :id="'file-' + id"
                        :data-homework="file.id"
                        :data-origin="file.origin"
                      >
                        <div class="c-file__icon">
                          <span class="c-file__ok">
                            <i class="iconf-ok d-flex align-items-center"></i>
                          </span>
                          <i class="iconf-doc-empty d-flex align-items-center"></i>
                        </div>
                        <div class="c-file__name-container">
                          <div class="c-file__name">
                            <div class="c-file__ncarrousel">
                              <p class="mb-0">{{ file.name }}</p>
                              <p class="mb-0">{{ message }}</p>
                            </div>
                          </div>
                          <div class="c-file__walk">
                            <div
                              class="c-file__progress"
                              :style="'width:' + file.percentage + '%'"></div>
                          </div>
                        </div>
                        <div class="c-file__controls-container">
                          <div class="c-file__controls">
                            <div class="c-file__ccarrousel">
                              <div class="c-file__button-container">
                                <button
                                  class="c-file__cancel"
                                  @click="cancelUploadFile(file.id, file.origin, index)"
                                >
                                  <i class="icon-cancel d-flex align-items-center"></i>
                                </button>
                              </div>
                              <div class="c-file__button-container">
                                <button
                                  class="c-file__delete"
                                  @click="cancelUploadFile(file.id, file.origin, index)"
                                >
                                  <i class="iconf-trash d-flex align-items-center"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-pane fade" id="homework-link" role="tabpanel">
                  <input
                    type="url"
                    v-model="link"
                    class="c-form__input c-form__input--icon w-100 mb-2"
                    :class="{ 'filled': link }"
                    placeholder="ej. http://mega.nz/file/a5dafzx4"
                  />
                  <p class="mb-0 w-medium medium-gray fs-14">
                    Sólo admitimos enlaces de
                    <a href="https://drive.google.com" class="c-link" target="_blank">Google Drive</a>,
                    <a href="https://www.dropbox.com" class="c-link" target="_blank">Dropbox</a> y
                    <a href="https://onedrive.live.com" class="c-link" target="_blank">OneDrive</a>.
                    Recuerda habilitar la lectura y descarga en modo público,
                    verificalo visitando el enlace en modo incógnito.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <h3 class="white fs-18 w-bold mb-2">Comentarios</h3>
            <textarea
              v-model="description"
              class="c-form__textarea w-100"
              rows="3"
              placeholder="Describe tu tarea"
            >
            </textarea>
          </div>
          <div class="mb-4">
            <label class="c-form__checkbox-inline white">
              <input type="checkbox" v-model="community" class="d-none" />
              <div class="c-square">
                <span></span>
              </div>
              <span>
                Compartir mi trabajo en la
                <span
                  data-content="El lugar perfecto para compartir tus trabajos y recibir
                    feedback de otros compañeros, ¡Unete a la revolución!"
                  class="c-link c-tooltip-toggle ms-2">
                  Comunidad Arcux
                </span>
              </span>
            </label>
            <label v-if="formType === 'link'" class="c-form__checkbox-inline white mt-3">
              <input type="checkbox" v-model="confirmURL" class="d-none" />
              <div class="c-square">
                <span></span>
              </div>
              <span>
                Confirmo que el enlace de mi trabajo corresponde a uno de los
                servicios autorizados y tiene habilitado los permisos indicados.
              </span>
            </label>
          </div>
          <button
            :disabled="!sendButtonEnabled ? true : false"
            @click="sendHomework"
            class="c-button c-button--primary d-block w-100 mb-4"
            :class="isLoading ? 'loading loading--black' : ''"
          >
            Enviar trabajo
            <img
              class="c-button__spinner"
              src="../../assets/images/animations/spinner-white.png" alt="loading"
            />
          </button>
          <p class="w-medium medium-gray">
            ¿No puedes enviar tu trabajo?
            <button
              class="c-link d-inline-block ms-2"
              @click="handleOpenIssueModal('homework')"
            >
              <i class="iconf-warning me-2"></i>
              Reportar problema
            </button>
          </p>
        </div>
      </div>
    </section>
    <section v-if="showHomeworkReceivedMessage" class="c-admin-message p-3 p-md-4 mb-4">
      <div class="row justify-content-center align-items-center">
        <div class="col col-12 col-md-8 col-lg-6 mb-4 md-md-0">
          <figure class="c-admin-message__vector mb-5">
            <img
              class="w-100 h-100 of--contain"
              src="../../assets/images/lection/homework/homework.png" alt=""
            />
          </figure>
          <div class="text-center">
            <h3 class="white fs-21 w-bold">¡Trabajo recibido!</h3>
            <p class="mb-2 w-medium medium-gray">
              Gracias por enviar tu trabajo, lo revisaremos en los proximos dias ({{ nextMonday }})
            </p>
            <p class="mb-0 w-medium medium-gray">¡Un abrazo!</p>
          </div>
        </div>
      </div>
    </section>
    <section v-if="showCongratulationsMessage" class="c-admin-message p-3 p-md-4 mb-4">
      <div class="row justify-content-center align-items-center">
        <div class="col col-12 col-md-8 col-lg-6 mb-4 md-md-0">
          <figure class="c-admin-message__vector mb-5">
            <img
              class="w-100 h-100 of--contain"
              src="../../assets/images/lection/homework/graduate.png" alt=""
            />
          </figure>
          <div class="text-center">
            <h3 class="white fs-21 w-bold">¡Felicidades!</h3>
            <p class="mb-2 w-medium medium-gray mb-4">
              Conseguiste aprobar el curso <a href="#" class="c-link">{{ course.title }}</a>
            </p>
            <a :href="certificate.url" class="c-button c-button--primary d-inline-block mb-5">
              Descargar certificado
            </a>
            <h3 class="white fs-21 w-bold mb-4">¿Con ganas de aprender más?</h3>
            <a
              :href="`/usuario/${ user.username }`"
              class="c-button c-button--primary-ghost d-inline-block"
            >
              Seguir aprendiendo
            </a>
            <p class="w-medium medium-gray mt-5">
              ¿Hay algún problema con tu certificado?
              <button
                class="c-link d-inline-block ms-2"
                @click="handleOpenIssueModal('certificate')"
              >
                <i class="iconf-warning me-2"></i> Reportar problema
              </button>
            </p>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import 'dm-file-uploader';
import tippy from 'tippy.js';
import { mapState, mapMutations } from 'vuex';
import Avatar from '../Avatar.vue';
import ModalHomework from './modals/ModalHomework.vue';

export default {
  data() {
    return {
      arcux: window.arcux,
      id: 0,
      step: 0,
      state: 0,
      counter: 0,
      certificate: {},
      review: {},
      message: '',
      files: {
        temp: {},
        data: [],
      },
      isHomeworkLoaded: false,
      description: '',
      link: '',
      community: false,
      confirmURL: false,
      isLoading: false,
      isSent: false,
      formType: 'files',
    };
  },
  components: {
    Avatar,
    ModalHomework,
  },
  props: ['course', 'content', 'last', 'user'],
  computed: {
    ...mapState({
      userFilled: (state) => state.user.userFilled,
    }),
    isTeacher: {
      get() {
        return this.user.role === 'teacher' || this.user.role === 'teacher-pro';
      },
    },
    homeworkGrid: {
      get() {
        return ['col col-12', { 'col-md-6': !this.isTeacher }];
      },
    },
    nextMonday: {
      get() {
        const date = new Date();

        date.setDate((date.getDate() + (1 + 7 - date.getDay())) % 7);

        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);

        return `${day}, ${month} ${year}`;
      },
    },
    sendButtonEnabled: {
      get() {
        return (this.formType === 'files' && this.files.data.length > 0) || (this.formType === 'link' && this.link && this.link.length > 5 && this.confirmURL);
      },
    },
    showPresentationMessage: {
      get() {
        return this.step === 0 && !this.isTeacher;
      },
    },
    showLastActivityAlert: {
      get() {
        return this.state === 2 && !this.isSent && this.course.teachers.length;
      },
    },
    showHomeworkForm: {
      get() {
        return (this.step === 0 || this.showLastActivityAlert) && (!this.isSent || this.isTeacher);
      },
    },
    showHomeworkReceivedMessage: {
      get() {
        return this.state === 1 && this.isSent && !this.isTeacher;
      },
    },
    showCongratulationsMessage: {
      get() {
        return this.state === 3 && this.isSent && !this.isTeacher && this.certificate;
      },
    },
    firstTeacher: {
      get() {
        return this.course.teachers.length
          ? this.course.teachers[0]
          : {};
      },
    },
    lastLectionRoute: {
      get() {
        return this.last ? `/curso/${this.course.slug}/lecciones/${this.last.moduleNumber}/${this.last.lectionSlug}/` : '';
      },
    },
  },
  created() {
    this.getHomework();
  },
  mounted() {
    this.initTooltips();
  },
  methods: {
    /* eslint-disable */
    ...mapMutations([
      'updateUserFilled',
    ]),
    init() {
      $('#drop-area').dmUploader({
        auto: true,
        queue: true,
        url: `${this.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}/homeworks/${this.id}/files/`,
        method: 'POST',
        maxFileSize: 300000000, // 300 Mbs
        dataType: 'json',
        extraData: () => {
          return {
            '_wpnonce': this.arcux._secret,
            'userId': this.user.id,
            'courseId': this.$route.params.course_id,
            'homeworkId': (this.id) ? this.id : 0,
            'homeworkStep': (this.step) ? this.step + 1 : 1,
            'fileNumber': this.counter,
          }
        },
        extFilter: ['png', 'jpg', 'jpeg', 'zip', 'rar', 'mp4', 'mwv', 'avi', 'pdf'],
        onNewFile: this.addNewFile,
        onUploadProgress: this.updateProgressFile,
        onUploadCanceled: this.handleCancel,
        onBeforeUpload: this.handleBeforeUpload,
        onUploadError: this.handleError,
        onUploadSuccess: this.handleUploadSuccess,
        onUploadComplete: this.handleUploadComplete,
        onFileSizeError: this.handleFileSizeError,
        onFileExtError: this.handleFileExtError,
      });
    },
    getFiles() {
      /* TODO: API */
      let request = `${this.arcux.site}/api/v1/courses/${ this.$route.params.course_id }/students/${ this.user.id }/homeworks/${this.id}/files/`

      fetch(request)
        .then(res => {
          if(res.status == 200 || res.status < 300) {
            return res.json()
          } else{
            throw res;
          }
        })
        .then(files => {
          this.files.data = files.data.map(file => {
            return {
              id: file.id,
              name: file.name,
              origin: 1,
              percentage: 100,
            }
          });

          this.counter = this.files.data.length;
        })
        .catch(err => {
          throw err;
        })
    },
    getHomework(){
      /* TODO: API */
      let url = `${this.arcux.site}/api/v1/courses/${ this.$route.params.course_id }/students/${ this.user.id }/homeworks/?moduleId=${this.$route.params.module}&lesson=${this.$route.params.lection_slug}`

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(res => {
          if(res.status == 200 || res.status < 300) {
            return res.json()
          }else{
            throw res;
          }
        })
        .then(homework => {
          this.id = homework.id;
          this.step = homework.step;
          this.state = homework.state;
          this.review = homework.review;
          this.certificate = (homework.certificate) ? homework.certificate : {};
          this.community = homework.community;
          this.isSent = (homework.state == 1 || homework.state == 3) ? true : false;
          this.isHomeworkLoaded = true;


          if(this.state == 0) {
            this.getFiles();
          }

          this.$nextTick(() => {
              this.init();
          })
        })
        .catch(err => {})
    },
    sendHomework(){
      event.preventDefault();

      if(!this.userFilled) {
        this.$bvModal.show('modalHomework');
      } else {
        this.handleSendHomework();
      }
    },
    handleSendHomework() {
      /* TODO: API */
      this.isLoading = true;
      const request = `${this.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}/homeworks/${this.id}/`;

      fetch(request, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          moduleId: this.$route.params.module,
          lesson: this.$route.params.lection_slug,
          comment: this.description,
          homeworkStep: this.step + 1,
          link: this.formType === 'link' ? this.link : '',
          community: this.community,
          userFirstName: this.user.first_name,
          userLastName: this.user.last_name,
        }),
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            this.isLoading = false;
            this.isSent = true;
            this.step += 1;
            this.state = 1;

            this.updateUserFilled({
              userFilled: true,
            });

            this.$bvModal.hide('modalHomework');
          }

          throw res;
        })
        .catch((err) => {
          throw err;
        });
    },
    handleBeforeUpload() {
      this.counter = this.counter + 1;
    },
    cancelUploadFile(id, origin = 0, index) {
      /* TODO: API */
      if (!origin) {
        $('#drop-area').dmUploader('cancel', id);
      }

      const fileId = (!origin) ? this.files.data[this.files.temp[id]]._id : id;
      const request = `${this.arcux.site}/api/v1/courses/${this.$route.params.course_id}/students/${this.user.id}/homeworks/files/${fileId}`;

      fetch(request, {
        method: 'DELETE',
      })
        .then((res) => {
          if(res.status == 200 || res.status < 300) {
            return res.json()
          } else{
            throw res;
          }
        })
        .then(response => {
          this.message = 'Archivo eliminado';
          this.files.data[index].percentage = 0;

          this.handleDeleteFile(id);
        })
        .catch(err => {
          err.text().then( errorMessage => { this.message = JSON.parse(errorMessage).message });
        })
    },
    addNewFile(id, file) {
      this.files.data.push({
        _id: -1,
        id: id,
        name: file.name,
        origin: 0,
        percentage: 0,
      });

      this.files.temp[id] = this.files.data.length - 1;
    },
    updateProgressFile(id, percent) {
      this.files.data[this.files.temp[id]].percentage = percent;
    },
    handleError(id) {
      this.files.data[this.files.temp[id]].status = -1;
    },
    handleCancel(id) {
      this.files.data[this.files.temp[id]].status = -2;
      this.files.data[this.files.temp[id]].percentage = 0;
    },
    handleUploadSuccess(id, data) {
      this.files.data[this.files.temp[id]]._id = data.data.id;
    },
    handleUploadComplete(id) {
      $('#file-' + id).addClass('uploaded');
    },
    handleFileSizeError(file) {
      this.handleAddErrorFile(file, 'Archivo muy pesado.');
      this.handleDeleteFile(file.size);
    },
    handleFileExtError(file) {
      this.handleAddErrorFile(file, 'Archivo no permitido.');
      this.handleDeleteFile(file.size);
    },
    handleAddErrorFile(file, message) {
      this.counter = this.counter + 1;

      this.files.data.push({
        id: file.size,
        name: message,
        origin: 1,
        percentage: 0,
      });
    },
    handleDeleteFile(id) {
      setTimeout(() => {
        this.files.data = this.files.data.filter((file) => file.id !== id);
        delete this.files.temp[id];

        this.counter -= 1;
      }, 3000);
    },
    handleChangeFormType(type) {
      this.formType = type;
    },
    handleOpenIssueModal(type) {
      this.$emit('open-issue-modal', type);
    },
    initTooltips() {
      window.setTimeout(() => {
        tippy('.c-tooltip-toggle', {
          content(reference) {
            return `<p class="c-tooltip c-tooltip--tiny">
          ${reference.getAttribute('data-content')}
        </p>
      `;
          },
          allowHTML: true,
          theme: 'light',
          animation: 'scale',
          inertia: true,
        });
      }, 2000);
    },
  },
};
</script>
